import React from 'react';

const TypingIndicator = () => {
  return (
    <div className="typing-indicator">
      <style>
        {`
          @keyframes typing {
            0% { opacity: 0.3; }
            50% { opacity: 1; }
            100% { opacity: 0.3; }
          }

          .typing-indicator {
            display: flex;
            align-items: center;
            gap: 4px;
          }

          .dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #3b82f6;
            animation: typing 1.5s infinite ease-in-out;
          }

          .dot:nth-child(1) { animation-delay: 0s; }
          .dot:nth-child(2) { animation-delay: 0.3s; }
          .dot:nth-child(3) { animation-delay: 0.6s; }
        `}
      </style>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  );
};

export default TypingIndicator;
